import React, { useEffect, useState } from 'react';
import './Layout.scss';
import AppSidebar from '../sidebar/Sidebar.jsx';
import { motion } from "framer-motion";
import Header from "../header/Header.jsx"
import { Drawer } from "@material-tailwind/react";
import CustomBreadcrumb from '../customBreadcrumb/CustomBreadcrumb.jsx';
import { useLocation } from 'react-router-dom';
import TermsAndConditionsPopup from './componets/TermsAndConditionsPopup.jsx';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../../hooks/useResponsive.js';
import MobileLayout from './MobileLayout.jsx';

export default function AppLayout({ children, ib, title = "UpForex CRM", parent }) {
    const { isMobile } = useResponsive();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(true);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { userDetails } = useSelector((state) => state.user);

    useEffect(() => {
        setIsDrawerOpen(false);
    }, [location]);

    // Render mobile layout for mobile screens
    if (isMobile) {
        return <MobileLayout children={children} ib={ib} title={title} />;
    }

    return (
        <div>
            <div className='flex '>
                <motion.div className='hidden lg:block' animate={{ marginLeft: collapsed ? "0px" : "-250px", transition: { duration: 0.5 } }}>
                    <AppSidebar ib={ib} />
                </motion.div>
                <div className={`bg-white lg:ml-[250px] ${collapsed ? 'lg:w-[calc(100%-250px)]' : 'lg:w-full'} w-full `} >
                    <Header collapsed={collapsed} title={title} setCollapsed={setCollapsed} isDrawerOpen={isDrawerOpen} setIsDrawerOpen={setIsDrawerOpen} ib={ib} />

                    <div className='p-2 md:p-4'>
                        <CustomBreadcrumb title={title} parent={parent} ib={ib} />
                    </div>

                    <div className='px-2 md:px-4 pb-2 md:pb-4'>
                        {children}
                    </div>
                </div>
            </div>

            <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(!isDrawerOpen)} className={`top-0 left-0 h-[100vh] lg:hidden w-full z-10 ${isDrawerOpen ? 'sidebar-drawer' : 'w-auto'}`}>
                <AppSidebar ib={ib} />
                <div className='fixed left-[260px] top-[10px]'>
                    <svg onClick={() => setIsDrawerOpen(false)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer lg:hidden">
                        <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                    </svg>
                </div>
            </Drawer>

            {!userDetails.isAcceptTermsAndCondition && <TermsAndConditionsPopup />}
        </div>
    )
}
